var moduleMap = {
	"./store": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(236), __webpack_require__.e(982)]).then(() => (() => ((__webpack_require__(8986)))));
	},
	"./Menu": () => {
		return Promise.all([__webpack_require__.e(729), __webpack_require__.e(124), __webpack_require__.e(867), __webpack_require__.e(236), __webpack_require__.e(898), __webpack_require__.e(982), __webpack_require__.e(197)]).then(() => (() => ((__webpack_require__(1946)))));
	},
	"./Basket": () => {
		return Promise.all([__webpack_require__.e(729), __webpack_require__.e(124), __webpack_require__.e(867), __webpack_require__.e(236), __webpack_require__.e(898), __webpack_require__.e(763), __webpack_require__.e(982), __webpack_require__.e(886)]).then(() => (() => ((__webpack_require__(8763)))));
	},
	"./pwaService": () => {
		return __webpack_require__.e(475).then(() => (() => ((__webpack_require__(1475)))));
	},
	"./PlacementPreview": () => {
		return __webpack_require__.e(662).then(() => (() => ((__webpack_require__(6662)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});